<template>
  <tr
      :style="getRowStyle(line)"
      :class="[{'onOpenChild': onOpenChild}, {'children': isChildren}, `${this.flag}RowTr`]"
  >

    <td class="td" v-if="isIndexNumber">{{ indexNumber }}</td>
    <td
        v-for="(item, index) in headers"
        :key="index"

        :class="[
						'td', item.value,
						 { 'filter-active': filterClasses[item.valueFilter] || getFilterActive(item.value),
							  'tdButtons': (item.buttons || item.links),
							  'tdSticky': item.sticky
						 }]"
        @dblclick="onEdit({line, index})"
    >

      <field
          v-if="item.isCheckbox"
          margin="0"
          padding="0"
          height="24"
          :switch-value="isCheck"
          @updateSwitch="onCheckbox"
          :is-disabled="isPermCheckbox(line)"
          is-dense
          is-checkbox
          is-off-style
      ></field>

	    <div
			    v-else
			    class="wrapper"
			    :style="{
				    color: hasColor(item.value),
				    width: item.width || 'inherit'
				  }"
	    >
        <div v-if="item.buttons || item.links" class="buttonsWrap">
          <template v-if="item.buttons">
            <div v-if="item.buttonsValue">{{ line[item.value] }}</div>
            <div v-if="item.isButtonsWithLink" :class="['valueTd', item.align]">
              <a class="linkClassic" :href="line[item.linkClassic]" target="_blank">{{ line[item.value] }}</a>
            </div>
            <div
                v-for="({ perm, download, value, icon, text, copied, copiedSuccess, withoutPerm, isCanDisabled, hasData }, index) in item.buttons"
                :key="index"
            >
	            <template v-if="!hasData || (line && line[hasData])">
	              <tool-tip :text="getTextToolTip({ value, text })" content-class="left">
	                <copied-btn
	                    v-if="line[value] && copied"
	                    :value="line[value]"
	                    :icon="icon.value"
	                    :iconW="icon.w"
	                    :iconH="icon.h"
	                    :copiedSuccess="copiedSuccess"
	                ></copied-btn>

	                <component
	                    v-if="!copied"
	                    :is="download ? 'a' : 'button'"
	                    class="v-btn"
	                    :class="{'isDisabled': getDisabled({ perm, value, line, withoutPerm, isCanDisabled })}"
	                    :href="download && getHref(line)"
	                    :download="download"
	                    target="_blank"
	                    @click="download ? void 0 : onClickButton({key: value, item: line, index})"
	                    rel="noopener noreferrer"
	                >
	                  <svg-sprite :width="icon.w" :height="icon.h"
	                              :icon-id="getIconAccordingPerm({ icon: icon.value, value })"></svg-sprite>
	                </component>
	              </tool-tip>
	            </template>
            </div>
          </template>
        </div>

        <template v-else-if="item.childElements === 'Parent' && !isChild">
          <td-child
              @updateChild="onChild"
              @updateOpen="onOpen"
              :line="line"
              :isOpenChild="onOpenChild"
          ></td-child>
        </template>

        <div v-else-if="item.checkbox" class="checkboxWrap">
          <v-checkbox
              v-model="selected"
              :label="line[item.value]"
              @change="onCheckboxDS($event, line)"
          ></v-checkbox>
        </div>

        <div v-else-if="item.isStatus" :class="['valueTd', item.align]">
          <span
              :style="getStatusStyle({ filterKey: item.value, iconValue: line[item.value] })"
              class="valueTd__svg">
              <svg-sprite :width="20" :height="20"
                          :icon-id="getStatusIcon({ filterKey: item.value, iconValue: line[item.value] })"
              ></svg-sprite>
          </span>
        </div>

        <div v-else-if="item.icons" :class="['valueTd', item.align]">
          <div v-for="(icon, index) in item.icons" :key="index">
            <span
                :style="getIconStyle({ filterKey: item.value, iconValue: icon.value })"
                class="valueTd__svg">
                <svg-sprite :width="icon.w" :height="icon.h" :icon-id="icon.id"></svg-sprite>
            </span>
          </div>
        </div>

        <div v-else-if="item.modText" :class="['valueTd', item.align]">
          <span
              :class="['valueTd__text', {'nowrap':item.nowrap}]"
              :style="onStyle({ line, filterKey: item.value })"
          >
	          {{ getLineMod({line, filterKey: (item.childValue || item.value)}) }}
          </span>
        </div>

        <div v-else-if="item.isSwitch">
          <span class="switchWrapper">
	              <v-switch
			              v-model="line[item.value]"
			              :disabled="isSwitchDisabled({ action:item.action, actionGroup:item.actionGroup, value: line[item.value], line: line })"
			              @change="statusSwitch({value:item.value, cancel:item.actionGroupCancel})"
	              ></v-switch>
          </span>
        </div>

<!--        <div v-else-if="item.isCount" :class="['valueTd eldCount', item.align]">
          <button
              :disabled="!line[item.value]"
              :style="`background: ${line[item.value] ? '#077e1e' : 'rgba(255, 255, 255, 0.3)'} `"
              @click="onEldList"
          >
            {{ line[item.value] }}
          </button>
        </div>-->

	      <div v-else-if="item.counter" :class="['valueTd', item.align]">
		      <span @click="onCounter(item.value)" class="descN">{{ line[item.value] }}</span>
	      </div>
<!--        <div v-else-if="item.linkClassic" :class="['valueTd', item.align]">-->
<!--          <a class="linkClassic" :href="line[item.linkClassic]" target="_blank">{{ line[item.value] }}</a>-->
<!--        </div>-->

<!--        <div v-else-if="item.modal" :class="['valueTd', item.align]">-->
<!--          <span class="modalLink" @click="onModal(item.value)">{{ line[item.value] }}</span>-->
<!--        </div>-->

        <div v-else-if="item.file" :class="['valueTd', item.align]">
          <button :disabled="getFileDisabled({ line, item })" @click="onFile(line[item.value])">
            <svg-sprite
                :width="item.file.w"
                :height="item.file.h"
                :icon-id="item.file.iconId"
            ></svg-sprite>
          </button>
        </div>

        <div v-else-if="item.statusColor" class="status">
          <span class="status_color" :style="`background: ${ line.color }`"></span>
          <span>{{ line[item.value] }}</span>
        </div>

        <div v-else-if="item.isPay" class="paid" :class="['valueTd', item.align]">
          <button :disabled="canPay(line)" @click="onPaid(item.value)">
            <svg-sprite width="20" height="20" icon-id="paid"></svg-sprite>
          </button>
        </div>
	      <div v-else-if="item.dollar && (line[item.value] || line[item.value] === 0)" :class="['valueTd', item.align]">

		      <template v-if="item.modValue === 'isDeCode'">
			      <de-code v-if="item.modValue === 'isDeCode'" :item="item" :line="line"/>
		      </template>
		      <template v-else>
			      <span class="valueTd__svg icon_dollars">$</span>
			      <div :class="['valueTd__text', {'nowrap': item.nowrap}]">{{ getCurrency(line[item.value]) }}</div>
		      </template>
	      </div>

        <div v-else-if="item.miles" :class="['valueTd', item.align]">
          <div :class="['valueTd__text', {'nowrap':item.nowrap}]">{{ line[item.value] }}</div>
          <span class="valueTd__svg icon_miles">{{ getUnits({line, filterKey: item.value}) }}</span>
        </div>

<!--		    Иконка с текстом-->
		    <div
				    v-else-if="
							item.iconValue &&
							line[item.iconValue.value] !== null &&
							line[item.iconValue.value] !== undefined &&
							line[item.iconValue.value] !== ''
						"
				    :class="['valueTd', item.align, item.iconValue.class]"
		      >
			    <svg-sprite
					    :width="item.iconValue.iconWidth || 12"
					    :height="item.iconValue.iconHeight || 12"
					    :icon-id="item.iconValue.icon"
			    ></svg-sprite>

			    <span class="value">
						{{ line[item.iconValue.value] }}
					</span>
		    </div>

        <div v-else-if="item.field" :class="['valueTd', item.align]">
          <field
              margin="0"
              width="100%"
              :placeholder=item.field.placeholder
              @updateInput="onFieldInput($event)"
              :setInputValue="line[item.value]"
          ></field>
        </div>
	      
	      <div v-else-if="item.modValue" :class="['valueTd', item.align]">
		      <vacation-days v-if="item.modValue === 'vacationDays'" :item="item" :line="line"></vacation-days>
		      <link-user v-if="item.modValue === 'linkUser'" :item="item" :line="line"></link-user>
		      <lost-type v-if="item.modValue === 'lostType'" :item="item" :line="line"></lost-type>
		      <mod-balance v-if="item.modValue === 'modBalance'" :item="item" :line="line"></mod-balance>
		      <mod-balance-tow v-if="item.modValue === 'modBalanceTow'" :item="item" :line="line"></mod-balance-tow>
		      <mod-log v-if="item.modValue === 'modLog'" :item="item" :line="line"></mod-log>
		      <date-time v-if="item.modValue === 'dateTime'" :item="item" :line="line"></date-time>
		      <date-time2 v-if="item.modValue === 'dateTime2'" :date="line.date" :time="line.time"/>
		      <date-time v-if="item.modValue === 'onlyDay'" :item="item" :line="line" only-day/>
		      <phone-u-s-a v-if="item.modValue === 'phoneUSA'" :item="item" :line="line"></phone-u-s-a>
		      <month-employee v-if="item.modValue === 'month_employee'" :item="item" :line="line"/>
<!--		      <de-code v-if="item.modValue === 'isDeCode'" :item="item" :line="line"/>-->

		      <div v-if="item.modValue === 'paidComplete'"><div class="paidComplete">Paid complete</div></div>

		      <customer-link v-if="item.modValue === 'isCustomerLink'" :item="item" :line="line"
            @updateModEvent="onModEvent($event)"/>
		      <count v-if="item.modValue === 'isCount'" :item="item" :line="line"
		        @updateModEvent="onModEvent($event)"/>
		      <input-cell v-if="item.modValue === 'isInputCell'" :item="item" :line="line"
            @updateModEvent="onModEvent($event)"></input-cell>

	      </div>

        <div v-else :class="['valueTd', item.align]">
          <div :class="['valueTd__text', {'nowrap': item.nowrap}]">
            {{ getClip(line[item.childValue || item.value], item.clip) }}
          </div>
        </div>

      </div>
    </td>
  </tr>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
// components
import TdChild from "@/shared/MainTable/RowTr/TdChild/TdChild";
import ToolTip from "@/shared/ToolTip/ToolTip";
import CopiedBtn from "@/components/Safety/Logbooks/SafetyCalendar-list/CopiedBtn";
// helpers
import { formatCurrency } from "@/helper";
import { filterActive } from "@/helper/getFilterClassesActive";
// Constants

import {
	FILTER_KEYS,
	PAGE,
	TAB,
	PERMISSIONS,
	STATUS_COLOR,
	STATUS_TEXT,
	TABLE_COLOR,
	TRAILER_TYPE,
	TYPE_OF_COUNT
} from "@/constants/constants";
import { SHORT_PAYMENTS_STATUS } from "@/pages/Accounting/ShortPayments/constants";
import { getAppUrl } from "@/services";
import { FLAGS_OF_TABLE } from "@/shared/MainTable/RowTr/constants";
import VacationDays from "@/shared/MainTable/RowTr/VacationDays/VacationDays.vue";
import { getPermissionsMod } from "@/helper/getPermissionsMod";
import LinkUser from "@/shared/MainTable/RowTr/LinkUser/LinkUser.vue";
import LostType from "@/shared/MainTable/RowTr/LostType/LostType.vue";
import ModBalance from "@/shared/MainTable/RowTr/ModBalance/ModBalance.vue";
import ModBalanceTow from "@/shared/MainTable/RowTr/ModBalanceTow/ModBalanceTow.vue";
import ModLog from "@/shared/MainTable/RowTr/ModLog/ModLog.vue";
import { getAcceptFiles } from "@/helper/getAcceptFiles";
import { isDownloadFile } from "@/helper/isDownloadFile";
import DateTime from "@/shared/MainTable/RowTr/DateTime/DateTime.vue";
import PhoneUSA from "@/shared/MainTable/RowTr/PhoneUSA/PhoneUSA.vue";
import MonthEmployee from "@/shared/MainTable/RowTr/MonthEmployee/MonthEmployee.vue";
import DateTime2 from "@/shared/MainTable/RowTr/DateTime2/DateTime2.vue";
import CustomerLink from "@/shared/MainTable/RowTr/CustomerLink/CustomerLink.vue";
import Count from "@/shared/MainTable/RowTr/Count/Count.vue";
import InputCell from "@/shared/MainTable/RowTr/InputCell/InputCell.vue";
import DeCode from "@/shared/MainTable/RowTr/DeCode/DeCode.vue";

export default {
	name: "RowTr",
	components: {
		DeCode,
		InputCell,
		Count,
		CustomerLink,
		DateTime2,
		MonthEmployee,
		PhoneUSA,
		DateTime,
		ModLog,
		ModBalanceTow,
		ModBalance,
		LostType,
		LinkUser,
		VacationDays: VacationDays,
		TdChild,
		ToolTip,
		CopiedBtn
	},
	props: {
		flag: String,
		isChild: Boolean,
		headers: Array,
		department_id: Number,
		line: Object,
		checkAll: Boolean,
		filterClasses: Object,
		safetyStatus: Array,
		safetyDrivingHours: Array,
		changeCheckedAll: Boolean,
		isIndexNumber: Boolean,
		indexNumber: Number,
		index: Number,
		page: Number,
		itemsPerPage: [ Number, String ],
		isChildren: Boolean,
		isRefresh: String,
		isRefreshCheckbox: String,
		isCloseChildren: String
	},
	watch: {
		isRefresh(val, oldVal) {
			if (val !== oldVal) {
				this.isCheck = false;
			}
		},
		isRefreshCheckbox(val, oldVal) {
			if (val !== oldVal) {
				this.isCheck = false;
			}
		},
		changeCheckedAll(val, oldVal) {
			if (val !== oldVal) {
				this.selectedisCheck = val;
			}
		},
		isCloseChildren(val, oldVal) {
			if (val !== oldVal) {
				this.onOpenChild = false;
			}
		},
		checkAll(val) {
			if (this.flag === 'customersBulkChange') {
				this.isCheck = val;
				this.line.isCheck = val;
				return;
			}

			if (this.line.status !== 'Open') {
				this.isCheck = val;
				this.line.isCheck = val;
			}
		},
		// checkAll(val) {
		// 	if (this.line.status !== 'Open') {
		// 		this.isCheck = val;
		// 		this.line.isCheck = val;
		// 	}
		// },
	},
	computed: {
		...mapGetters([ 'permissions', 'permissionsDefault', 'role', 'isLogin' ]),
	},
	data: () => ({
		selected: false,
		onOpenChild: false,
		isCheck: false,
	}),
	methods: {
		...mapActions([
			'setAlert'
		]),
		
		/**
		 * Визначає, чи потрібно дизейблити чекбокс.
		 * @param {Object} line - Рядок/об'єкт інвойсу (містить статус тощо).
		 * @returns {boolean} Повертає true, якщо чекбокс треба дизейблити.
		 */
		// isPermCheckbox(line) {
		// 	// ✅ MODAL customersBulkChange: allow selecting any status
		// 	if (this.flag === 'customersBulkChange') return false;
		//
		// 	if ( this.flag === 'tableHolidayDepartment' ) {
		// 		const list = this.permissionsDefault;
		// 		const path = [ PERMISSIONS.SETTINGS, PERMISSIONS.USER_ACCOUNT_SETTINGS, PERMISSIONS.U_A_S_HOLIDAYS, PERMISSIONS.EDIT ];
		// 		const isCheckbox = getPermissionsMod({ list, path });
		// 		return !isCheckbox;
		// 	}
		//
		// 	const list = this.permissionsDefault;
		// 	const path = [ PERMISSIONS.ACCOUNTING, PERMISSIONS.CUSTOMER_INVOICES, PERMISSIONS.SEND ];
		// 	const perm = getPermissionsMod({ list, path });
		//
		// 	if (!perm) return true;
		//
		// 	const { status } = line;
		// 	return status === 'Open';
		// },

		isPermCheckbox(line) {

			// ✅ MODAL customersBulkChange: allow selecting any status
			if (this.flag === 'customersBulkChange') return false;

			if ( this.flag === 'tableHolidayDepartment' ) {
				const list = this.permissionsDefault;
				const path = [ PERMISSIONS.SETTINGS, PERMISSIONS.USER_ACCOUNT_SETTINGS, PERMISSIONS.U_A_S_HOLIDAYS, PERMISSIONS.EDIT ];
				const isCheckbox = getPermissionsMod({ list, path });
				return !isCheckbox;
			}

			const list = this.permissionsDefault;
			const path = [ PERMISSIONS.ACCOUNTING, PERMISSIONS.CUSTOMER_INVOICES, PERMISSIONS.SEND ];
			const perm = getPermissionsMod({ list, path }); // true = є право, false = права немає

			// Якщо немає права — дизейбл одразу
			if (!perm) return true;

			const { status } = line;
			// return status === 'Open' || (invoice_status && invoice_status === 'Paid');
			return status === 'Open';
		},

		isSwitchDisabled({ action, actionGroup, line }) {
			if (actionGroup && actionGroup.length > 0 && !action) {
				const result = actionGroup
					.filter(key => key in line)
					.map(key => line[key]);
				return !result.some(element => Boolean(element));
			} else if (action && !actionGroup) {
				return !line[action];
			}

			const list = this.permissionsDefault;
			const path = [ PERMISSIONS.ACCOUNT, PERMISSIONS.ACCOUNT_COMMENTS, PERMISSIONS.EDIT ];
			const perm = getPermissionsMod({ list, path });

			if (this.flag === TAB.ACCOUNT_TAB_ALL_USERS_COMMENTS) return !perm;
		},

		getClip(message, clip) {
			if ((clip && message) && message.length > clip) {
				const clipMessage = message.slice(0, clip);
				return clipMessage + '...';
			}
			return message;
		},
		statusSwitch({ value, cancel }) {
			this.$emit("updateStatusSwitch", { line: this.line, value, cancel });
		},

		hasColor(value) {
			const { category, type } = this.line;

			const isCreditDeductionTable = this.flag === FLAGS_OF_TABLE.CREDIT_DEDUCTION_TABLE;
			const isRelevantCreditValue = [
				TYPE_OF_COUNT.CATEGORY,
				TYPE_OF_COUNT.AMOUNT
			].includes(value);

			if (isCreditDeductionTable && isRelevantCreditValue) {
				const creditDeductionMapping = {
					[TYPE_OF_COUNT.DEDUCTION]: STATUS_COLOR[4],
					[TYPE_OF_COUNT.CREDIT]: STATUS_COLOR[3]
				};
				return creditDeductionMapping[category] || '';
			}

			const isBonusOrSalaryTable = [
				TAB.USER_TAB_BONUS_CHARGE,
				TAB.ACCOUNT_TAB_BONUS_CHARGE,
				FLAGS_OF_TABLE.BONUS_CHARGE,
				FLAGS_OF_TABLE.SAFETY_ST_VIEW,
				FLAGS_OF_TABLE.SALARY_HISTORY_SLIDE
			].includes(this.flag);

			const isRelevantBonusValue = [
				TYPE_OF_COUNT.TYPE,
				TYPE_OF_COUNT.TOTAL,
				TYPE_OF_COUNT.AMOUNT
			].includes(value);

			if (isBonusOrSalaryTable && isRelevantBonusValue) {
				const bonusChargeMapping = {
					[TYPE_OF_COUNT.BONUS]: STATUS_COLOR[3],
					[TYPE_OF_COUNT.SALARY]: STATUS_COLOR[3],
					[TYPE_OF_COUNT.CHARGE]: STATUS_COLOR[4]
				};
				return bonusChargeMapping[type] || '';
			}

			return '';
		},

		getCurrency(total) {
			if (Object.is(total, -0)) return formatCurrency(0);
			return formatCurrency(total);
		},

		getFilterActive(filterKey) {
			return filterActive({ filterKey, filterClasses: this.filterClasses });
		},
		getUnits(value) {
			const { line, filterKey } = value;

			if (this.flag === PAGE.TRAILERS) {
				const hh = (line[filterKey] || line[filterKey] === 0) && line.trailer_type === TRAILER_TYPE.REEFER ? 'hh' : 'mi';
				return line[filterKey] ? hh : "";
			}

			return line[filterKey] ? 'mi' : "";
		},
		onStyle(value) {
			const { line, filterKey } = value;
			if ((this.flag === PAGE.DRIVERS && filterKey === FILTER_KEYS.SAFETY) ||
          (this.flag === PAGE.DRIVERS && filterKey === FILTER_KEYS.SERVICE) ||
          (this.flag === PAGE.TRUCKS && filterKey === FILTER_KEYS.COMPANY_OWNER) ||
          (this.flag === PAGE.TRUCKS && filterKey === FILTER_KEYS.ACTIVE) ||
          (this.flag === PAGE.TRUCKS && filterKey === FILTER_KEYS.LEFT_COMPANY) ||
          (this.flag === PAGE.TRUCKS && filterKey === FILTER_KEYS.SOLD) ||
          (this.flag === PAGE.TRAILERS && filterKey === FILTER_KEYS.COMPANY_OWNER) ||
          (this.flag === PAGE.TRAILERS && filterKey === FILTER_KEYS.ACTIVE) ||
          (this.flag === PAGE.TRAILERS && filterKey === FILTER_KEYS.LEFT_COMPANY) ||
          (this.flag === PAGE.TRAILERS && filterKey === FILTER_KEYS.SOLD) ||
          (this.flag === PAGE.TRAILERS && filterKey === FILTER_KEYS.GPS) ||
          (this.flag === PAGE.USERS && filterKey === FILTER_KEYS.STATUS)) {
				return this.line[filterKey] ? `color: ${ STATUS_COLOR[3] };` : `color: ${ STATUS_COLOR[1] };`;
			}

			if ((this.flag === PAGE.CUSTOMERS && filterKey === FILTER_KEYS.BALANCE)) {
				if (line.balance < 0) return `color: ${ STATUS_COLOR[4] };`;
				if (line.balance > 0) return `color: ${ STATUS_COLOR[3] };`;
			}

			return false;
		},
		getRowStyle(args) {
			if ((this.flag === PAGE.SHORT_PAYMENTS)) {
				const { age, status } = args;

				if (status === SHORT_PAYMENTS_STATUS.COMPLETE
            || status === SHORT_PAYMENTS_STATUS.INACTIVE
            || status === SHORT_PAYMENTS_STATUS.PROCESSED) return false;

				if (age >= 30 && age <= 60) return `background: ${ TABLE_COLOR['1'] };`;

				if (age > 60) return `background: ${ TABLE_COLOR['2'] };`;
			}

			if ((this.flag === PAGE.LOGBOOKS)) {
				const { status_serves } = args;
				if (status_serves === 0) return `background: ${ TABLE_COLOR['3'] };`;
			}
			if ((this.flag === PAGE.TRIP_FILES) || (this.flag === PAGE.TRIP_NOTES )) {
				const { status } = args;
				if (status === 'new' || status === 'edit') return `background: ${ TABLE_COLOR['4'] };`;
			}

			if (this.flag === TAB.ACCOUNT_TAB_VACATION) {
				if (!args.head_status && !args.main_status) return `background: ${ TABLE_COLOR['5'] };`;
			}

			if (this.flag === PAGE.TRIP_LIST) {
				const list = this.permissionsDefault;
				const { customer_invoice, dispatcher_id } = args;
				const { employee_id, role } = this.isLogin;

				if (customer_invoice) return `background: ${ TABLE_COLOR['3'] };`;

				const pathEditMod = [
					PERMISSIONS.DISPATCH,
					PERMISSIONS.TRIPS,
					PERMISSIONS.CREATE_EDIT_TRIP
				];

				const permEditMod = getPermissionsMod({ list, path: pathEditMod });

				const isDispatcherRole = Number(role) === 1;
				const isSameEmployee = Number(employee_id) === Number(dispatcher_id);

				// подсветка только для диспетчера если это не его трип
				if (permEditMod && isDispatcherRole && !isSameEmployee) {
					return `background: ${ TABLE_COLOR['3'] };`;
				}
			}

			return false;
		},
		getLineMod(value) {
			const { line, filterKey } = value;

			if (this.flag === PAGE.TRIP_LIST) {
				const { load_id, trip_id } = line;
				return this.isChild ? `Load: ${ load_id }` : `Trip: ${ trip_id }`;
			}

			if ((this.flag === PAGE.DRIVERS && filterKey === FILTER_KEYS.SAFETY) ||
          (this.flag === PAGE.DRIVERS && filterKey === FILTER_KEYS.SERVICE) ||
          (this.flag === PAGE.TRUCKS && filterKey === FILTER_KEYS.COMPANY_OWNER) ||
          (this.flag === PAGE.TRUCKS && filterKey === FILTER_KEYS.ACTIVE) ||
          (this.flag === PAGE.TRUCKS && filterKey === FILTER_KEYS.LEFT_COMPANY) ||
          (this.flag === PAGE.TRUCKS && filterKey === FILTER_KEYS.SOLD) ||
          (this.flag === PAGE.TRAILERS && filterKey === FILTER_KEYS.COMPANY_OWNER) ||
          (this.flag === PAGE.TRAILERS && filterKey === FILTER_KEYS.ACTIVE) ||
          (this.flag === PAGE.TRAILERS && filterKey === FILTER_KEYS.LEFT_COMPANY) ||
          (this.flag === PAGE.TRAILERS && filterKey === FILTER_KEYS.SOLD) ||
          (this.flag === PAGE.TRAILERS && filterKey === FILTER_KEYS.GPS) ||
          (this.flag === PAGE.USERS && filterKey === FILTER_KEYS.STATUS)) {
				return this.line[filterKey] ? STATUS_TEXT.ACTIVE : STATUS_TEXT.INACTIVE;
			}

			if ((this.flag === PAGE.TRUCKS && filterKey === FILTER_KEYS.ELD)) {
				const { eld, eld_name } = line;
				return eld ? eld_name : '-';
			}

			if ((this.flag === PAGE.CUSTOMERS && filterKey === FILTER_KEYS.BALANCE)) {
				return this.line[filterKey];
			}

			return '';
		},

		getStatusStyle(item) {
			const validPairs = [
				[ PAGE.WORK_ORDERS, FILTER_KEYS.ARRIVED ],
				[ PAGE.CUSTOMERS, FILTER_KEYS.FROZEN ],
				[ PAGE.LOGBOOKS, FILTER_KEYS.STATUS_SERVES ],
				[ PAGE.LOGBOOKSMOD, FILTER_KEYS.STATUS_SERVES ],
				[ PAGE.BILLING, FILTER_KEYS.BOL ],
				[ PAGE.TRIP_PAYMENTS, FILTER_KEYS.CONSIDER_BOOLEAN ],
				[ PAGE.FACTORING, FILTER_KEYS.JOIN_PPW ],
				[ PAGE.EMPLOYEES, FILTER_KEYS.ACTIVE ],
				[ PAGE.TABSCHEDULE, FILTER_KEYS.STATUS ],
				[ PAGE.TRIP_LIST, FILTER_KEYS.AI_STATUS ],
				[ PAGE.INCOME_TRANSACTIONS, FILTER_KEYS.PAID ],
			];

			if (validPairs.some(([ page, key ]) => this.flag === page && item.filterKey === key)) {
				return `color: ${ item.iconValue ? STATUS_COLOR[3] : STATUS_COLOR[1] }`;
			}
		},

		getStatusIcon(item) {
			const validPairs = [
				[ PAGE.WORK_ORDERS, FILTER_KEYS.ARRIVED ],
				[ PAGE.CUSTOMERS, FILTER_KEYS.FROZEN ],
				[ PAGE.LOGBOOKS, FILTER_KEYS.STATUS_SERVES ],
				[ PAGE.LOGBOOKSMOD, FILTER_KEYS.STATUS_SERVES ],
				[ PAGE.BILLING, FILTER_KEYS.BOL ],
				[ PAGE.TRIP_PAYMENTS, FILTER_KEYS.CONSIDER_BOOLEAN ],
				[ PAGE.FACTORING, FILTER_KEYS.JOIN_PPW ],
				[ PAGE.EMPLOYEES, FILTER_KEYS.ACTIVE ],
				[ PAGE.TABSCHEDULE, FILTER_KEYS.STATUS ],
				[ PAGE.TRIP_LIST, FILTER_KEYS.AI_STATUS ],
				[ PAGE.INCOME_TRANSACTIONS, FILTER_KEYS.PAID ],
			];

			if (validPairs.some(([ page, key ]) => this.flag === page && item.filterKey === key)) {
				return item.iconValue ? 'st_true' : 'st_false';
			}
		},

		getIconStyle(item) {
			const { filterKey, iconValue } = item;

			if (this.flag === PAGE.WORK_ORDERS && filterKey === FILTER_KEYS.OPTIONAL) {
				return this.line[iconValue] ? `color: ${ STATUS_COLOR[3] }` : `color: ${ STATUS_COLOR[1] }`;
			}

			return false;

		},

		getIconAccordingPerm({ icon }) {
			if ( this.flag === TAB.USER_TAB_BONUS_CHARGE ) return icon;
			if ( this.flag === TAB.ACCOUNT_TAB_BONUS_CHARGE ) return icon;
			if ( this.flag === PAGE.TRIP_LIST ) return icon;

			// if (value === 'edit') {
			// 	if (this.flag === PAGE.DRIVER_STATEMENTS) {
			// 		if (this.line.status === 'Close') return 'eye';
			// 	}
			//
			// 	if (this.permissions[PERMISSIONS.EDIT] || !(this.permissions[PERMISSIONS.EDIT] || this.permissions[PERMISSIONS.VIEW])) return icon;
			// 	// if (!this.permissions[PERMISSIONS.EDIT] && this.permissions[PERMISSIONS.VIEW]) return 'eye';
			// }

			return icon;
		},
		getTextToolTip({ text }) {
			if ( this.flag === TAB.USER_TAB_BONUS_CHARGE ) return text;
			if ( this.flag === TAB.ACCOUNT_TAB_BONUS_CHARGE ) return text;
			if ( this.flag === PAGE.TRIP_LIST ) return text;

			// if (value === 'edit') {
			// 	if (this.flag === PAGE.DRIVER_STATEMENTS) {
			// 		if (this.line.status === 'Close') return 'View';
			// 	}
			//
			// 	if (this.permissions[PERMISSIONS.EDIT] || !(this.permissions[PERMISSIONS.EDIT] || this.permissions[PERMISSIONS.VIEW])) return text;
			// 	// if (!this.permissions[PERMISSIONS.EDIT] && this.permissions[PERMISSIONS.VIEW]) return 'View';
			// }

			return text;
		},

		getDisabled({ perm, value, line, withoutPerm, isCanDisabled }) {
			const { employee_id } = this.isLogin;

			if ( this.flag === PAGE.BILLING ) {
				return !line['ppw_url'];
			}
			if ( this.flag === 'UserListActions' ) {
				if (value === "view") return !getAcceptFiles(line.file);

				const list = this.permissionsDefault;
				const pathDelete = [ PERMISSIONS.SAFETY, PERMISSIONS.LOGBOOKS, PERMISSIONS.DELETE ];
				const permDelete = getPermissionsMod({ list, path: pathDelete });
				if (employee_id === line['employee_id'] && value === 'delete' ) {
					return false;
				} else if (value === 'delete' ) {
					return !permDelete;
				}

				const pathEdit = [ PERMISSIONS.SAFETY, PERMISSIONS.LOGBOOKS, PERMISSIONS.EDIT ];
				const permEdit = getPermissionsMod({ list, path: pathEdit });
				if (employee_id === line['employee_id'] && value === 'edit' ) {
					return false;
				} else if (value === 'edit' ) {
					return !permEdit;
				}
			}
			if ( this.flag === TAB.EXCEPTION_TABLE_MODAL ) {
				if (value === "view") return !getAcceptFiles(line.file);

				if (value === 'delete' && !line.action_delete) return true;
			}
			if ( this.flag === PAGE.TABSCHEDULE ) {
				const list = this.permissionsDefault;

				const pathEdit = [ PERMISSIONS.SETTINGS, PERMISSIONS.USER_ACCOUNT_SETTINGS, PERMISSIONS.U_A_S_SCHEDULE, PERMISSIONS.EDIT ];
				const permEdit = getPermissionsMod({ list, path: pathEdit });
				if (value === 'edit1' ) return !permEdit;

				const pathDelete = [ PERMISSIONS.SETTINGS, PERMISSIONS.USER_ACCOUNT_SETTINGS, PERMISSIONS.U_A_S_SCHEDULE, PERMISSIONS.DELETE ];
				const permDelete = getPermissionsMod({ list, path: pathDelete });
				if (value === 'delete1' ) return !permDelete;
			}
			if ( this.flag === PAGE.INCOME_TRANSACTIONS ) {
				const list = this.permissionsDefault;

				const pathEdit = [ PERMISSIONS.ACCOUNTING, PERMISSIONS.INCOME_TRANSACTIONS, PERMISSIONS.EDIT ];
				const permEdit = getPermissionsMod({ list, path: pathEdit });
				if (value === 'edit1' ) return !permEdit;

				if (
					value === "paid" &&
					(line.customer === null || line.paid === 1)
				) return true;

			}
			if ( this.flag === TAB.HOLIDAYS ) {
				const list = this.permissionsDefault;

				const pathEdit = [ PERMISSIONS.SETTINGS, PERMISSIONS.USER_ACCOUNT_SETTINGS, PERMISSIONS.U_A_S_HOLIDAYS, PERMISSIONS.EDIT ];
				const permEdit = getPermissionsMod({ list, path: pathEdit });
				if (value === 'edit1' ) return !permEdit;

				const pathDelete = [ PERMISSIONS.SETTINGS, PERMISSIONS.USER_ACCOUNT_SETTINGS, PERMISSIONS.U_A_S_HOLIDAYS, PERMISSIONS.DELETE ];
				const permDelete = getPermissionsMod({ list, path: pathDelete });
				if (value === 'delete1' ) return !permDelete;
			}
			if ( this.flag === TAB.OFFICE ) {
				const list = this.permissionsDefault;

				const pathEdit = [ PERMISSIONS.SETTINGS, PERMISSIONS.USER_ACCOUNT_SETTINGS, PERMISSIONS.U_A_S_OFFICE, PERMISSIONS.EDIT ];
				const permEdit = getPermissionsMod({ list, path: pathEdit });
				if (value === 'edit1' ) return !permEdit;

				const pathDelete = [ PERMISSIONS.SETTINGS, PERMISSIONS.USER_ACCOUNT_SETTINGS, PERMISSIONS.U_A_S_OFFICE, PERMISSIONS.DELETE ];
				const permDelete = getPermissionsMod({ list, path: pathDelete });
				if (value === 'delete1' ) return !permDelete;
			}
			if ( this.flag === TAB.INVENTORY ) {
				const list = this.permissionsDefault;

				const pathEdit = [ PERMISSIONS.SETTINGS, PERMISSIONS.USER_ACCOUNT_SETTINGS, PERMISSIONS.U_A_S_INVENTORY, PERMISSIONS.EDIT ];
				const permEdit = getPermissionsMod({ list, path: pathEdit });
				if (value === 'edit1' ) return !permEdit;

				const pathDelete = [ PERMISSIONS.SETTINGS, PERMISSIONS.USER_ACCOUNT_SETTINGS, PERMISSIONS.U_A_S_INVENTORY, PERMISSIONS.DELETE ];
				const permDelete = getPermissionsMod({ list, path: pathDelete });
				if (value === 'delete1' ) return !permDelete;
			}
			if ( this.flag === TAB.CONTACTS_TYPES ) {
				const list = this.permissionsDefault;

				const pathEdit = [ PERMISSIONS.SETTINGS, PERMISSIONS.USER_ACCOUNT_SETTINGS, PERMISSIONS.U_A_S_CONTACTS, PERMISSIONS.EDIT ];
				const permEdit = getPermissionsMod({ list, path: pathEdit });
				if (value === 'edit1' ) return !permEdit;

				const pathDelete = [ PERMISSIONS.SETTINGS, PERMISSIONS.USER_ACCOUNT_SETTINGS, PERMISSIONS.U_A_S_CONTACTS, PERMISSIONS.DELETE ];
				const permDelete = getPermissionsMod({ list, path: pathDelete });
				if (value === 'delete1' ) return !permDelete;
			}

			if ( this.flag === TAB.DOCUMENTS_TYPES ) {
				const list = this.permissionsDefault;

				const pathEdit = [ PERMISSIONS.SETTINGS, PERMISSIONS.USER_ACCOUNT_SETTINGS, PERMISSIONS.U_A_S_DOCUMENTS, PERMISSIONS.EDIT ];
				const permEdit = getPermissionsMod({ list, path: pathEdit });
				if (value === 'edit1' ) return !permEdit;

				const pathDelete = [ PERMISSIONS.SETTINGS, PERMISSIONS.USER_ACCOUNT_SETTINGS, PERMISSIONS.U_A_S_DOCUMENTS, PERMISSIONS.DELETE ];
				const permDelete = getPermissionsMod({ list, path: pathDelete });
				if (value === 'delete1' ) return !permDelete;
			}

			if ( this.flag === TAB.DEPARTMENTS ) {
				const list = this.permissionsDefault;

				const pathEdit = [ PERMISSIONS.SETTINGS, PERMISSIONS.USER_ACCOUNT_SETTINGS, PERMISSIONS.U_A_S_DEPARTMENTS, PERMISSIONS.EDIT ];
				const permEdit = getPermissionsMod({ list, path: pathEdit });
				if (value === 'edit1' ) return !permEdit;

				const pathDelete = [ PERMISSIONS.SETTINGS, PERMISSIONS.USER_ACCOUNT_SETTINGS, PERMISSIONS.U_A_S_DEPARTMENTS, PERMISSIONS.DELETE ];
				const permDelete = getPermissionsMod({ list, path: pathDelete });
				if (value === 'delete1' ) return !permDelete;
			}

			if ( this.flag === TAB.POSITIONS ) {
				const list = this.permissionsDefault;

				const pathEdit = [ PERMISSIONS.SETTINGS, PERMISSIONS.USER_ACCOUNT_SETTINGS, PERMISSIONS.U_A_S_POSITIONS, PERMISSIONS.EDIT ];
				const permEdit = getPermissionsMod({ list, path: pathEdit });
				if (value === 'edit1' ) return !permEdit;

				const pathDelete = [ PERMISSIONS.SETTINGS, PERMISSIONS.USER_ACCOUNT_SETTINGS, PERMISSIONS.U_A_S_POSITIONS, PERMISSIONS.DELETE ];
				const permDelete = getPermissionsMod({ list, path: pathDelete });
				if (value === 'delete1' ) return !permDelete;
			}

			if ( this.flag === TAB.COMPANIES ) {
				const list = this.permissionsDefault;

				const pathEdit = [ PERMISSIONS.SETTINGS, PERMISSIONS.USER_ACCOUNT_SETTINGS, PERMISSIONS.U_A_S_COMPANY, PERMISSIONS.EDIT ];
				const permEdit = getPermissionsMod({ list, path: pathEdit });
				if (value === 'edit1' ) return !permEdit;

				const pathDelete = [ PERMISSIONS.SETTINGS, PERMISSIONS.USER_ACCOUNT_SETTINGS, PERMISSIONS.U_A_S_COMPANY, PERMISSIONS.DELETE ];
				const permDelete = getPermissionsMod({ list, path: pathDelete });
				if (value === 'delete1' ) return !permDelete;
			}

			if ( this.flag === 'driverFilesList' ) {
				if (value === "eye") return !getAcceptFiles(line.name || line.value);
				if (value === "download") return (!getAcceptFiles(line.name || line.value) || isDownloadFile(line.file || line.value));
				if (value === "delete") return line.category?.toLowerCase() === "contract";
			}
			if ( this.flag === 'customerFilesList' ) {
				if (value === "eye") return !getAcceptFiles(line.name);
				if (value === "download") return (!getAcceptFiles(line.name) || isDownloadFile(line.url || line.file));
				// if (value === "delete") return line.category?.toLowerCase() === "contract";
			}

			if ( this.flag === PAGE.CUSTOMER_PAYMENTS ) {
				if (value === "visibility") return !line.file;
			}

			if ( this.flag === PAGE.INVOICE ) {
				if (value === "open") return !this.permissions[PERMISSIONS.OPEN_INVOICE] || (line.status === 'Open' );
			}

			if ( this.flag === PAGE.DRIVER_STATEMENTS ) {
				if (value === "delete") return line.status === 'Closed';
			}

			if ( this.flag === TAB.ACCOUNT_TAB_VACATION ) {

				if (line.head_status || line.main_status) return true;

				const list = this.permissionsDefault;

				const pathEditMod = [ PERMISSIONS.ACCOUNT, PERMISSIONS.ACCOUNT_VACATION, PERMISSIONS.EDIT ];
				const permEditMod = getPermissionsMod({ list, path: pathEditMod });
				if (value === 'editMod' ) return !permEditMod;

				const pathDeleteMod = [ PERMISSIONS.ACCOUNT, PERMISSIONS.ACCOUNT_VACATION, PERMISSIONS.DELETE ];
				const permDeleteMod = getPermissionsMod({ list, path: pathDeleteMod });
				if (value === 'deleteMod' ) return !permDeleteMod;
			}
			if ( this.flag === TAB.ACCOUNT_TAB_STATEMENTS ) {
				const list = this.permissionsDefault;
				const path = [ PERMISSIONS.ACCOUNT, PERMISSIONS.ACCOUNT_ST_TS, PERMISSIONS.DELETE ];
				const perm = getPermissionsMod({ list, path });
				if (value === 'delete1' ) return !perm;
			}
			if ( this.flag === "invoice" ) {
				if (value === 'send' ) {
					const list = this.permissionsDefault;
					const path = [ PERMISSIONS.ACCOUNTING, PERMISSIONS.CUSTOMER_INVOICES, PERMISSIONS.SEND ];
					const perm = getPermissionsMod({ list, path }); // true = є право, false = права немає

					// Якщо немає права — дизейбл одразу
					if (!perm) return true;

					const { status } = line;
					// return status === 'Open' || (invoice_status && invoice_status === 'Paid');
					return status === 'Open';
				}
			}

			if ( this.flag === TAB.USER_TAB_SALARY_HISTORY_SLIDE ) {
				const list = this.permissionsDefault;
				const path = [ PERMISSIONS.ACCOUNT, PERMISSIONS.ACCOUNT_USERS, PERMISSIONS.ACCOUNT_USER_SALARY_HISTORY, PERMISSIONS.DELETE ];
				const perm = getPermissionsMod({ list, path });
				if (value === 'delete1' ) return !perm;
			}

			if ( this.flag === TAB.ACCOUNT_TAB_SALARY_HISTORY_SLIDE ) {
				const list = this.permissionsDefault;
				const path = [ PERMISSIONS.ACCOUNT, PERMISSIONS.ACCOUNT_USERS, PERMISSIONS.ACCOUNT_SALARY_HISTORY, PERMISSIONS.DELETE ];
				const perm = getPermissionsMod({ list, path });
				if (value === 'delete1' ) return !perm;
			}
			if ( this.flag === PAGE.LOST_PAYMENTS ) {
				const list = this.permissionsDefault;
				const path = [ PERMISSIONS.ACCOUNTING, PERMISSIONS.LOST_PAYMENTS, PERMISSIONS.DELETE ];
				const perm = getPermissionsMod({ list, path });
				if (value === 'delete' ) return !perm;
			}

			if ( this.flag === TAB.ACCOUNT_TAB_BONUS_CHARGE ) {
				const list = this.permissionsDefault;
				const { action_delete } = line;

				const pathEditMod = [ PERMISSIONS.ACCOUNT, PERMISSIONS.ACCOUNT_BONUS_CHARGE, PERMISSIONS.EDIT ];
				const permEditMod = getPermissionsMod({ list, path: pathEditMod });
				if (value === 'edit' ) return !permEditMod;

				if (value === 'delete' && !!action_delete) return true;

				const pathDeleteMod = [ PERMISSIONS.ACCOUNT, PERMISSIONS.ACCOUNT_BONUS_CHARGE, PERMISSIONS.DELETE ];
				const permDeleteMod = getPermissionsMod({ list, path: pathDeleteMod });
				if (value === 'delete' ) return !permDeleteMod;
			}
			if (this.flag === PAGE.TRIP_LIST) {
				const list = this.permissionsDefault;
				const { customer_invoice, dispatcher_id } = line;
				const { employee_id, role } = this.isLogin;

				if (value === 'edit' && customer_invoice) return true;
				if (value === 'delete' && customer_invoice) return true;

				const isDispatcherRole = Number(role) === 1;
				const isSameEmployee = Number(employee_id) === Number(dispatcher_id);

				const hasAccessByRole = (permission) => {
					if (!permission) return false;

					// для диспетчера (role === 1) нужен и permission, и совпадение employee_id
					if (isDispatcherRole) {
						return isSameEmployee;
					}

					// для всех остальных достаточно permission
					return true;
				};

				const pathViewMod = [ PERMISSIONS.DISPATCH, PERMISSIONS.TRIPS, PERMISSIONS.VIEW ];
				const permViewMod = getPermissionsMod({ list, path: pathViewMod });

				if (value === 'view') {
					return !hasAccessByRole(permViewMod);
				}

				const pathDownloadMod = [ PERMISSIONS.DISPATCH, PERMISSIONS.TRIPS, PERMISSIONS.DOWNLOAD_DOC ];
				const permDownloadMod = getPermissionsMod({ list, path: pathDownloadMod });

				if (value === 'download') {
					return !hasAccessByRole(permDownloadMod);
				}

				const pathDeleteMod = [
					PERMISSIONS.DISPATCH,
					PERMISSIONS.TRIPS,
					PERMISSIONS.CREATE_EDIT_TRIP,
					PERMISSIONS.DELETE_TRIP
				];
				const permDeleteMod = getPermissionsMod({ list, path: pathDeleteMod });

				if (value === 'delete') {
					return !hasAccessByRole(permDeleteMod);
				}

				const pathEditMod = [
					PERMISSIONS.DISPATCH,
					PERMISSIONS.TRIPS,
					PERMISSIONS.CREATE_EDIT_TRIP
				];
				const permEditMod = getPermissionsMod({ list, path: pathEditMod });

				if (value === 'edit') {
					return !hasAccessByRole(permEditMod);
				}
			}

			if ( this.flag === TAB.USER_TAB_BONUS_CHARGE ) {
				const list = this.permissionsDefault;
				const { action_delete } = line;

				const pathEditMod = [ PERMISSIONS.ACCOUNT, PERMISSIONS.ACCOUNT_USERS, PERMISSIONS.ACCOUNT_USER_BONUS_CHARGE, PERMISSIONS.EDIT ];
				const permEditMod = getPermissionsMod({ list, path: pathEditMod });
				if (value === 'edit' ) return !permEditMod;
				
				if (value === 'delete' && !!action_delete) return true;

				const pathDeleteMod = [ PERMISSIONS.ACCOUNT, PERMISSIONS.ACCOUNT_USERS, PERMISSIONS.ACCOUNT_USER_BONUS_CHARGE, PERMISSIONS.DELETE ];
				const permDeleteMod = getPermissionsMod({ list, path: pathDeleteMod });
				if (value === 'delete' ) return !permDeleteMod;

			}

			if ( this.flag === TAB.USER_TAB_ST_ST__SAFETY
					|| this.flag === TAB.USER_TAB_ST_ST__ALL
					|| this.flag === PAGE.MANAGER_STATEMENTS
					|| this.flag === TAB.USER_TAB_ST_ST__DISPATCHERS ) {

				// 1, name: "Safety"
				// 2, name: "Dispatch head"
				// 3, name: "Sales manager"
				// 4, name: "Sales head"
				// 5, name: "Safety head"
				// 6, name: "Afterhours"
				// 7, name: "Dispatch"
				// 8, name: "HR"
				// 9, name: "Accounting"
				// 10, name: "Security"
				// 11, name: "IT"
				// 12, name: "Altex dispatchers"
				const hideBtnVIEW = [ 6, 8, 9, 11 ].includes(this.department_id);

				if (hideBtnVIEW) if (value === 'openLoads' ) return true;
				if (!hideBtnVIEW) if (value === 'openLoads' ) return false;

				const list = this.permissionsDefault;

				const pathEditMod = [ PERMISSIONS.ACCOUNT, PERMISSIONS.ACCOUNT_USERS, PERMISSIONS.ACCOUNT_USER_BONUS_CHARGE, PERMISSIONS.EDIT ];
				const permEditMod = getPermissionsMod({ list, path: pathEditMod });
				if (value === 'openLoads' ) return !permEditMod;

				const pathDeleteMod = [ PERMISSIONS.ACCOUNT, PERMISSIONS.ACCOUNT_USERS, PERMISSIONS.ACCOUNT_USER_BONUS_CHARGE, PERMISSIONS.DELETE ];
				const permDeleteMod = getPermissionsMod({ list, path: pathDeleteMod });
				if (value === 'delete' ) return !permDeleteMod;
			}

			if ( perm && typeof perm === 'string' && line[perm] === 0 ) return true;

			if ( isCanDisabled ) return line.status === 'Open';

			if ( withoutPerm ) return false;

			if ( value === 'edit' ) return !(this.permissions[PERMISSIONS.EDIT] || (this.permissions[PERMISSIONS.VIEW] || this.permissions[PERMISSIONS.VIEW_FILES]));

			if ( value === 'delete' ) return !(this.permissions[PERMISSIONS.DELETE] || this.permissions[PERMISSIONS.DELETE_TRIP]);

			return false;
		},

		getFileDisabled({ line, item }) {
			const list = this.permissionsDefault;

			if (this.flag === TAB.ACCOUNT_TAB_BONUS_CHARGE) {
				const path = [ PERMISSIONS.ACCOUNT, PERMISSIONS.ACCOUNT_BONUS_CHARGE, PERMISSIONS.VIEW ];
				const hasPermission = !getPermissionsMod({ list, path });
				const isLineFalse = !line[item.value];
				return !(hasPermission === false && isLineFalse === false);
			}

			if (this.flag === TAB.USER_TAB_BONUS_CHARGE) {
				const path = [ PERMISSIONS.ACCOUNT, PERMISSIONS.ACCOUNT_USERS, PERMISSIONS.ACCOUNT_USER_BONUS_CHARGE, PERMISSIONS.VIEW ];
				const hasPermission = !getPermissionsMod({ list, path });
				const isLineFalse = !line[item.value];
				return !(hasPermission === false && isLineFalse === false);
			}

			return !line[item.value];
		},

		getHref(item) {
			if (this.flag === 'tripFiles') {
				return getAppUrl + item['image'] ?? '';
			}
			if (this.flag === PAGE.BILLING) {
				return getAppUrl + item['ppw_url'] ?? '';
			}

			if (
				(this.flag === PAGE.REPORT_LIST) ||
					(this.flag === PAGE.REPORT_BILLING) ||
					(this.flag === 'tripItemFiles') ||
					(this.flag === 'driverFilesList') ||
					(this.flag === PAGE.REPORT_SAFETY)) {
				return getAppUrl + item.file ?? '';
			}
			if ((this.flag === 'customerFilesList')) {
				return getAppUrl + item.url ?? '';
			}
			if ((this.flag === 'invoiceFilesHeaders')) {
				return item.url ?? '';
			}

			return '';
		},
		onFieldInput(event) {
			this.$emit("updateFieldInput", { event, line: this.line });
		},
		onCounter(flag) {
			this.$emit('updateCounter', { flag, line: this.line });
		},
		onFile(value) {
			this.$emit('updateFile', value);
		},
		// onModal(flag) {
		// 	this.$emit('updateModal', { flag, line: this.line });
		// },
		canPay(args) {
			const list = this.permissionsDefault;

			const path = [ PERMISSIONS.ACCOUNTING, PERMISSIONS.CUSTOMER_INVOICES, PERMISSIONS.PAID ];
			const perm = getPermissionsMod({ list, path });

			if (!perm) return true;
			
			const { status } = args;

			// return status === 'Open' || (invoice_status && invoice_status === 'Paid');
			return status === 'Open';

		},
		onModEvent(args) {
			this.$emit('updateModEvent', args);
		},
		onPaid(flag) {
			this.$emit('updatePaid', { flag, line: this.line });
		},

		onCheckboxDS(value, item) {
			this.$emit("updateCheckboxDS", { value, item });
		},
		onClickButton(values) {
			this.$emit("updateClickButton", values);
		},
		onClickOutside() {
			this.isTooltip = false;
		},
		onEdit(value) {
			this.$emit("updateEdit", value);
		},
		onChild(value) {
			this.$emit("updateChild", value);
		},
		onOpen() {
			this.onOpenChild = !this.onOpenChild;
		},
		// onCheckbox({ value }) {
		// 	this.isCheck = value;
		// 	this.line.isCheck = value;
		//
		// 	let id;
		//
		// 	if (this.flag === 'customersBulkChange') {
		// 		id = this.line.customer_id; // ✅ ТОЛЬКО ТО, ЧТО НУЖНО
		// 	} else {
		// 		id =
		// 				this.line.id ??
		// 				this.line.reports_id ??
		// 				this.line.user_id ??
		// 				this.line.invoice_id ??
		// 				this.line.dispatcher_id;
		// 	}
		//
		// 	if (id == null) return; // защита
		//
		// 	this.$emit('updateCheckOrder', id, this.line);
		// }

		onCheckbox({ value }) {
			this.isCheck = value;
			this.line.isCheck = value;
			const id = this.line.id ?? (this.line.reports_id || this.line.user_id || this.line.invoice_id || this.line.dispatcher_id);
			this.$emit('updateCheckOrder', id, this.line);
		},

	},
	mounted() {
		this.isCheck = this.line.isCheck;
	}
};
</script>

<style lang="scss">
@import "RowTr";

</style>
<style lang="scss" scoped>
@import "RowTrScoped";

.paidComplete {
	white-space: nowrap;
}

</style>
